import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import nbNO from "antd/locale/nb_NO";
import "dayjs/locale/nb";
import App from "./App";
import EmbedApp from "./EmbedApp";
import { AuthProvider } from "./lib/auth";
import { gullTheme } from "./lib/theme";
import "./index.css";

// antd's nb_NO bundle has no Image entry, so the preview mask would fall back to English.
const locale = { ...nbNO, Image: { preview: "Se hele bildet" } };

// The frame TRY embeds gets its own root, chosen by path so the standalone app never learns it can
// be framed.
const EMBEDDED = window.location.pathname.startsWith("/embed/");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider locale={locale} theme={gullTheme}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            {EMBEDDED ? (
              <EmbedApp />
            ) : (
              <AuthProvider>
                <App />
              </AuthProvider>
            )}
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </StrictMode>,
);
